import { z } from 'zod';
import { DEFAULT_REFERRAL_EXPORT_FIELDS, REFERRAL_EXPORT_FIELDS, ReferralExportField } from '../referral-export';
import { ReferralListFilters, SUBMITTED_RANGE_ISSUE, submittedRangeOrdered } from './referral-review';

const splitList = (v: unknown) => {
  if (v === undefined || v === null) return undefined;
  const parts = (Array.isArray(v) ? v : [v]).flatMap((x) => (typeof x === 'string' ? x.split(',') : [x]));
  const trimmed = parts.map((p) => (typeof p === 'string' ? p.trim() : p)).filter((p) => p !== '');
  return trimmed.length ? trimmed : undefined;
};

export const ReferralExportFields = z.preprocess(
  splitList,
  z
    .array(ReferralExportField)
    .max(REFERRAL_EXPORT_FIELDS.length * 2)
    .default([...DEFAULT_REFERRAL_EXPORT_FIELDS])
    .transform((fields) => [...new Set(fields)]),
);

export const ReferralExportQuery = ReferralListFilters.extend({ fields: ReferralExportFields }).refine(submittedRangeOrdered, SUBMITTED_RANGE_ISSUE);
export type ReferralExportQuery = z.infer<typeof ReferralExportQuery>;

export const ReferralExportFilter = z.object({ label: z.string(), value: z.string() });
export type ReferralExportFilter = z.infer<typeof ReferralExportFilter>;

export const ReferralExportReport = z.object({
  generatedAt: z.string(),
  generatedBy: z.string(),
  filters: z.array(ReferralExportFilter),
  fields: z.array(ReferralExportField),
  headers: z.array(z.string()),
  rows: z.array(z.array(z.string())),
  referralCount: z.number().int(),
});
export type ReferralExportReport = z.infer<typeof ReferralExportReport>;
